module.exports = __webpack_public_path__ + "static/media/logo.1a4ddf48.jpeg";